import { render, staticRenderFns } from "./RequestCreatorServicePricesPopup.vue?vue&type=template&id=24572eac&scoped=true&"
import script from "./RequestCreatorServicePricesPopup.vue?vue&type=script&lang=js&"
export * from "./RequestCreatorServicePricesPopup.vue?vue&type=script&lang=js&"
import style0 from "./RequestCreatorServicePricesPopup.vue?vue&type=style&index=0&id=24572eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24572eac",
  null
  
)

export default component.exports